import React from "react";
import "./searchData.css";

const SearchData = ({
  type,
  placeholder,
  className,
  value,
  disabled,
  onChange,
  onkeyDown,
  maxLength
}) => {
  return (
    <div>
      <input
        className={`${className}`}
        id="search-bar"
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          if (e.target.value.includes("\\")) {
          
          } else {
            onChange(e);
          }
        }}
        disabled={disabled}
        onKeyDown={onkeyDown}
        maxLength={maxLength}
      />
    </div>
  );
};

export default SearchData;
